<template>
  <v-hover v-slot="{ hover }">
    <v-list-item @click="set_serie_attiva()">
      <v-list-item-avatar
        style="cursor: pointer"
        color="grey lighten-3"
        class="mr-2 mt-2"
        size="40"
      >
        <v-icon color="green">mdi-sprout</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          {{ serie.nome }}
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn v-if="hover" small icon color="red" @click="elimina_serie()"
          ><v-icon>mdi-delete</v-icon></v-btn
        >
      </v-list-item-action>
    </v-list-item>
  </v-hover>
</template>

<script>
export default {
  props: {
    id_specie: String,
    serie: Object,
  },
  data() {
    return {};
  },
  methods: {
    elimina_serie() {
      this.$store.dispatch("elimina_serie_specie", {
        id_specie: this.id_specie,
        id_serie: this.serie.id,
      });
    },
    set_serie_attiva() {
      this.$emit("set_serie_attiva", this.serie.id);
    },
  },
};
</script>